/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {
  JobBillingWorksheet,
  JobBillingWorksheetItem,
  JobRestService,
  MasterZoneRestService,
  OfficeRestService,
} from '@gh/builder-shared-data';
import {
  DictionaryService,
  getRouteQueryParams,
  InitViewService,
} from '@gh/common-shared';
import { ColumnEnableConditions, GridColumn, GridLayoutService } from '@gh/core-ui-grid';

import { BuilderUserContext } from '@gh/builder-shared';
import { Observable } from 'rxjs';
import { ENV_BASE_URL } from '@gh/config';
import { CMJobRestService } from './cm-job-rest.service';

@Injectable()
export class JobBillingWorksheetBusinessService implements InitViewService {

  COLUMN_ENABLE_CONDITION = {
    totalMasterFee:          (): boolean => this.corpAndAuNz(),
    totalOfficeFee:          (): boolean => this.masterOrUs(),
    totalOfficeVariationFee: (): boolean => this.masterOrUs(),
    officePaymentDue:        (): boolean => this.masterOrUs(),
    officePaidToDate:        (): boolean => this.masterOrUs(),
    officeLastPaymentDate:   (): boolean => this.masterOrUs(),
    officePaidAmount:        (): boolean => this.masterOrUs(),
    totalMasterVariationFee: (): boolean => this.corpAndAuNz(),
    masterPaymentDue:        (): boolean => this.corpAndAuNz(),
    masterPaidToDate:        (): boolean => this.corpAndAuNz(),
    masterLastPaymentDate:   (): boolean => this.corpAndAuNz(),
    masterPaidAmount:        (): boolean => this.corpAndAuNz(),
  } as ColumnEnableConditions;

  constructor(
    private jobRest: JobRestService,
    private cMJobRest: CMJobRestService,
    private userContext: BuilderUserContext,
    private masterZoneRest: MasterZoneRestService,
    private officeRest: OfficeRestService,
    private dictionaries: DictionaryService,
    private gridLayoutService: GridLayoutService,
  ) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    const params = getRouteQueryParams(route);
    const filter = params.filter;
    const filterObject = filter ? JSON.parse(filter) : {};
    if (filterObject.dateFrom) {
      filterObject.dateFrom = new Date (filterObject.dateFrom);
    }
    if (filterObject.dateTo) {
      filterObject.dateTo = new Date (filterObject.dateTo);
    }
    return {
      gridLayout: this.gridLayoutService.get('billingWorksheet', this.COLUMN_ENABLE_CONDITION),
      details:    this.getList(filterObject),
      filter: filterObject,
    };
  }

  getList(filter: any): Observable<JobBillingWorksheet> {
    return this.cMJobRest.getBillingWorksheet(filter);
  }

  getCountry(): string {
    const baseUrl = ENV_BASE_URL.toString();
    switch (true) {
      case baseUrl.includes('-au') || baseUrl.includes('.au'):
        return 'au';
      case baseUrl.includes('-nz') || baseUrl.includes('.nz'):
        return 'nz';
      case baseUrl.includes('-us') || baseUrl.includes('.com'):
        return 'us';
      default:
        return 'us';
    }
  }

  masterOrUs(): boolean {
    return this.userContext.masterView || this.getCountry() === 'us';
  }

  corpAndAuNz(): boolean {
    return this.userContext.corporateView && this.getCountry() !== 'us';
  }

  export(items: JobBillingWorksheetItem[], columns: GridColumn[]): Observable<{ url: string; fileName: string }> {
    return this.cMJobRest.exportBillingWorksheet(items, columns);
  }

  save(items: JobBillingWorksheetItem[]): Observable<JobBillingWorksheet> {
    return this.cMJobRest.saveBillingWorksheet(items);
  }
}
